<template>
  <img
      class="vsm--icon"
      :src="require(`../../assets/icons/sidebar${ active ? '/active/' : '/'}${icon.icon}.svg`)"
      alt=""
  >
</template>

<script>
export default {
  name: 'SidebarMenuIcon',
  props: {
    icon: {
      type: [String, Object],
      default: ''
    },
    active:{
      type: Boolean,
      default: false
    }
  }
}
</script>
